import { render, staticRenderFns } from "./Loja.vue?vue&type=template&id=4d35afe9&scoped=true"
import script from "./Loja.vue?vue&type=script&lang=js"
export * from "./Loja.vue?vue&type=script&lang=js"
import style0 from "./Loja.vue?vue&type=style&index=0&id=4d35afe9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d35afe9",
  null
  
)

export default component.exports